import { useEffect, useRef, useState } from "react";

export function useInViewport<T extends HTMLElement>(
  { threshold = 0.5, rootMargin = "100px" }: { threshold?: number; rootMargin?: string } = {}
) {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let mounted = true;
    const io = new IntersectionObserver(
      (entries) => {
        if (!mounted) return;
        const e = entries[0];
        setInView(e.isIntersecting && e.intersectionRatio >= threshold);
      },
      { threshold: [0, threshold, 1], rootMargin }
    );

    io.observe(el);
    return () => {
      mounted = false;
      io.disconnect();
    };
  }, [threshold, rootMargin]);

  return { ref, inView };
}
